export default "__VITE_ASSET__BOY2qZtB__"